import React from "react";
import Footer from "../Components/Login/Footer";
import LoginForm from "../Components/Login/LoginForm";
import LoginNav from "../Components/Login/LoginNav";
import styles from "./Styles/Login.module.css";

const Login = () => {
  return (
    <div className={styles.page}>
      <LoginNav />
      <div className={styles.main}>
        <LoginForm />
      </div>
      <Footer />
    </div>
  );
};

export default Login;
